/**
 * Fetch a file from a (signed) URL and trigger a browser download. Raw
 * fetch on purpose: the URL points outside our API (storage provider).
 */
export async function downloadFileFromUrl(
  url: string,
  filename: string,
): Promise<void> {
  const response = await fetch(url);
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
}
